export function waitForElement(
  selector: string,
  timeout = 3000,
  interval = 100
): Promise<HTMLElement> {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    const check = () => {
      const el = document.querySelector(selector) as HTMLElement | null;
      if (el) return resolve(el);
      if (Date.now() - start >= timeout) {
        return reject(new Error(`Element ${selector} not found after ${timeout}ms`));
      }
      setTimeout(check, interval);
    };

    check();
  });
}